import React, { CSSProperties } from 'react'
import Dropzone from 'react-dropzone'

// TODO: refactor CSS properties to a separate style module

const WRAPPER_STYLE = {
  display: 'table',
  width: '100%',
  minHeight: '200px',
}

const DROP_AREA_STYLE: CSSProperties = {
  width: '100%',
  display: 'table-cell',
  verticalAlign: 'middle',
  textAlign: 'center',
  border: '1px dashed #737373',
  borderRadius: '10px',
  background: 'white',
}

const DROP_AREA_ACTIVE_STYLE: CSSProperties = {
  width: '100%',
  display: 'table-cell',
  verticalAlign: 'middle',
  textAlign: 'center',
  border: '3px solid #305d9d',
  borderRadius: '10px',
  background: 'white',
}

const OPACITY_STYLE = {
  opacity: 0.2,
}

const NONE_STYLE = {}

interface Props {
  onDrop: any
  onDropRejected?: any
  children: React.ReactNode
  multiple?: boolean
  accept?: string | string[]
}

const DragAndDropUpload = ({
  onDrop,
  onDropRejected,
  multiple = true,
  accept,
  children,
}: Props) => (
  // @ts-ignore
  <Dropzone onDrop={onDrop} multiple={multiple} accept={accept} onDropRejected={onDropRejected}>
    {({ getRootProps, getInputProps, isDragActive }) => (
      <div {...getRootProps()} className={`dropzone${isDragActive ? ' dropzone--isActive' : ''}`}>
        <input {...getInputProps()} />
        <div style={WRAPPER_STYLE}>
          <div style={isDragActive ? DROP_AREA_ACTIVE_STYLE : DROP_AREA_STYLE}>
            <div style={isDragActive ? OPACITY_STYLE : NONE_STYLE}>{children}</div>
          </div>
        </div>
      </div>
    )}
  </Dropzone>
)

export default DragAndDropUpload
